import { useCallback, useEffect } from 'react';
import { useNavigate } from 'js/hooks/navigate';

import { EVOLUTION_EVENTS } from '../constants';

export const useRedirectHandler = ({ depositPage, responsibleGamingPage, lobbyPage }) => {
    const navigate = useNavigate({ redirect: true });
    const messageHandler = useCallback((message) => {
        switch (message?.data?.event) {
            case EVOLUTION_EVENTS.SHOW_DEPOSIT:
                navigate(depositPage);
                break;

            case EVOLUTION_EVENTS.SHOW_RESPONSIBLE_GAMING:
                navigate(responsibleGamingPage);
                break;

            case EVOLUTION_EVENTS.SESSION_INVALID:
                navigate(lobbyPage);
                break;

            default:
                // noop
        }
    }, [
        navigate,
        lobbyPage,
        depositPage,
        responsibleGamingPage
    ]);

    useEffect(() => {
        window.addEventListener('message', messageHandler);

        return () => {
            window.removeEventListener('message', messageHandler);
        };
    });
};
